import React from 'react';
import {
  EnvironmentRequestProduct,
  ProductNode,
  SelectedProduct,
  Vrops
} from 'vrlcm-gui-types';
import { majorVersion } from 'vrlcm-gui-utils';
import { IAAS_NODES } from '../constants/AppConstants';
import { dateFormatters, formatDate } from 'i18n/i18nUtil';

export function toViewArray(obj: any) {
  return Object.keys(obj).map(key => ({
    name: key,
    value: obj[key]
  }));
}

export const both = <T>(f1: (v: T) => boolean, f2: (v: T) => boolean) => (
  v: T
) => f1(v) && f2(v);

export const major = majorVersion;

export const isVropsCa = (product: SelectedProduct): product is Vrops => {
  return (
    product.id === 'vrops' &&
    product.type === 'new' &&
    (product as Vrops).caEnabled
  );
};

export const isEnvironmentProductVropsCa = (
  product: EnvironmentRequestProduct
) => {
  return product.id === 'vrops' && product.properties.isCaEnabled === 'true';
};

export const getVropsCa = (products: SelectedProduct[]) => {
  return products.find(isVropsCa);
};

export const isVra7 = (product: EnvironmentRequestProduct) =>
  product.id === 'vra' && major(product.version) === 7;

export const isNewNode = (node: ProductNode) =>
  node.properties.disabled !== 'true';

export const isIaasNode = (node: ProductNode) => IAAS_NODES.includes(node.type);

export const isIaasNewNode = both(isIaasNode, isNewNode);

export const hasIaasNewNode = (product: EnvironmentRequestProduct) =>
  product.nodes.some(isIaasNewNode);

export const isEnabledVraManualValidations = (
  products: EnvironmentRequestProduct[]
) => products.some(p => p.id === 'vra');

export const getLcmVersion = (version: string) => {
  const [maj, min, pat] = version.split('.');
  return `${maj}.${min}.${pat}`;
};

export function getDateFromTimestamp(timestamp: number) {
  if (timestamp) {
    return formatDate(timestamp, dateFormatters.FULL);
  }
  return '-';
}

export const useVidmToggle = (val?: boolean) => {
  const isVidmToggleChanged = React.useRef(val);
  React.useEffect(() => {
    isVidmToggleChanged.current = val;
    return () => {
      isVidmToggleChanged.current = false;
    };
  }, [val]);
  return isVidmToggleChanged;
};
